import { Header, Input, Icon } from "semantic-ui-react";
import { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination/Pagination.js";
import { TableComponent } from "../../../components/Table/table.js";
import BackButton from "../../../components/BackButton/BackButton.js";
import Loading from "../../../components/Loading/Loading.js";
import { api } from "../../../api/api.js";
import { erp_logs_url } from "../../../api/urls.js";
import axios from "axios";
import unknownError from "../../../utils/unknownError.js";
import { TextChip } from "../../../components/TextChip/TextChip.js";
import LogDetails from "./log_details.js";
import moment from "moment";

const title = "ERP Logs";
const apiUrl = erp_logs_url;
const searchFeild = "username";
// const searchFeild = "module_lable";
const headers = [
  "Users",
  "Modules",
  // "Entry id",
  "Action",
  "Timestamp",
  "IP",
  "",
];
const bodyMap = (d, refetch) => {
  return [
    <TitleSubtitle title={d.username} subTitle={d.email} />,
    <TitleSubtitle title={d.module_lable} />,
    // <TitleSubtitle title={d?.created_data?.id} />,
    <TextChip text={`${d.action}d`} color={statusToColor(d.action)} />,
    <TitleSubtitle
      title={moment(d.created_date).format("DD-MM-YYYY")}
      subTitle={moment(d.created_date).format("hh:mm:ss A")}
    />,
    <TitleSubtitle title={d.remote_ip_address} />,
    <LogDetails data={d} />,
  ];
};

function statusToColor(status) {
  let c = "#F4DCFF";
  switch (status) {
    case "Delete":
      c = "#FF4B4B";
      break;
    case "Create":
      c = "#AE5EFF";
      break;
    case "Update":
      c = "#5AA100";
      break;
    default:
      c = "#AE5EFF";
      break;
  }
  return c;
}

function TitleSubtitle({ title, subTitle }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <div>{title}</div>
      <div style={{ color: "#0000004D" }}>{subTitle}</div>
    </div>
  );
}

const ERPLogs = () => {
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [refetcher, setRefetcher] = useState(false);

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getData = async () => {
      setData();
      try {
        const res = await api.get(
          apiUrl + "?limit=" + limit + "&offset=" + offset,
          { cancelToken: source.token }
        );
        setData(res.data);
        setCount(res.data.count);
      } catch (err) {
        unknownError(err);
      }
    };
    getData();
    return () => {
      source.cancel();
    };
  }, [refetcher, limit, offset]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };

  return (
    <>
      <BackButton />
      <div id="heading">
        <Header>{title}</Header>
        <div className="right">
          <Input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name="search" link id="search-icon" />}
          />
        </div>
      </div>
      {data ? (
        <>
          <TableComponent
            headers={headers}
            align="center"
            body={
              data.results
                ? data.results
                    .filter((d) =>
                      d[searchFeild]
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    )
                    .map((d) => {
                      return bodyMap(d, refetch);
                    })
                : []
            }
            showbottom={false}
            disableHeaderPopup
          />
        </>
      ) : (
        <Loading />
      )}
      {count ? (
        <Pagination count={count} setLimit={setLimit} setOffset={setOffset} />
      ) : null}
    </>
  );
};

export default ERPLogs;
